import { poppins } from "@/components/common/fonts";
import { EnterpriseCell } from "./../Cell/index";
import { CheckOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Modal, Segmented, Switch } from "antd";
import styled from "styled-components";

export const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  position: relative;

  font-family: ${poppins.string};
  font-size: 16px;
  font-weight: 600;

  /* For below 768px screen width Jimmy */
  @media screen and (max-width: 768px) {
    flex-direction: column;
    min-width: auto;
    margin-bottom: 16px;
  }
`;

export const StyledBoldHeaderTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  height: 28px;
  margin-right: 20px;
`;

export const StyledHeaderSwitchText = styled.div`
  font-weight: 500;
  margin-right: 8px;
  color: #777777;
  font-size: 12px;
`;

export const StyledHeaderSwitchTextBold = styled.div`
  font-weight: 700;
  margin-right: 8px;
  font-size: 12px;
`;

export const StyledSwitch = styled(Switch)`
  margin-right: 8px;
`;

export const StyledListBodyDiv = styled.div`
  font-family: ${poppins.string};
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: stretch;

  /* For below 768px screen width Jimmy */
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const StyledCellDiv = styled.div`
  font-family: ${poppins.string};
  border: solid;
  border-width: 1px;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 14px 15px;
  width: 280px;
  min-height: 700px;

  border-color: #eaeaea;

  .button-wrapper {
    display: flex;
    justify-content: center;

    .block {
      height: 36px;
    }
  }
  /* For below 768px screen width Jimmy */

  .enterpriseText {
    font-size: 30px;
    margin-top: 20px;
    font-weight: 500;
  }

  .enterpriseSubText {
    margin-bottom: 46px;
    color: #999999;
  }

  .contact-text-sub {
    display: flex;
    justify-content: center;
    /* cursor: pointer; */
    color: #4276ee;
    height: 36px;
    align-items: center;
  }

  .downgrade-text-sub {
    display: flex;
    justify-content: center;
    /* cursor: pointer; */
    color: #4276ee;
    height: 36px;
    align-items: center;
    text-decoration: underline;
    cursor: pointer;
  }

  .contact-text {
    display: flex;
    justify-content: center;
    cursor: pointer;
    text-decoration: underline;
    color: #4276ee;

    &:hover {
      color: #4226ee;
    }
  }

  @media screen and (max-width: 768px) {
    /* width: auto; */
  }
`;

export const StyledCellTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  font-family: ${poppins.string};
`;

export const StyledCellSubtitle = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #777777;
  font-family: Montserrat;
`;

export const StyledCellButton = styled(Button)`
  border-radius: 4px;
  border-color: #3075f6;
  background-color: #3075f6;
  color: #ffffff;
  width: 226px;
  height: 36px;
  font-size: 12px;
  font-weight: 500;
  font-family: ${poppins.string};

  .enterpriseBtn {
    background-color: white;
    color: black;
  }
`;

export const StyledCellExplanationContainer = styled.div`
  /* margin-top: 30px; */
  padding: 0;
  margin-bottom: 5px;
  font-family: ${poppins.string};
  font-size: 13px;
  line-height: 20px;
  /* For below 768px screen width Jimmy */
  @media screen and (max-width: 768px) {
    margin-top: 6px;
    margin-bottom: 2px;
  }
`;

export const StyledCellExplanationLine = styled.div`
  display: flex;
  /* align-items: center; */
  /* justify-content: center; */

  flex-direction: column;
  .main {
    display: flex;
  }
  margin-top: 6px;
`;

export const StyledCheckIcon = styled(CheckOutlined)`
  color: #3075f6;
  margin-right: 5px;
`;

export const StyledExplanationSubTitle = styled.div`
  font-family: ${poppins.string};
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;
  color: #000000;
  margin-top: 10px;
  margin-left: 15px;
`;

export const StyledNormalExplanationText = styled.div`
  font-weight: 400;
  font-size: 13px;
  color: #444444;
  /* margin-right: 5px; */
  font-family: ${poppins.string};
`;

export const StyledBoldExplanationText = styled.div`
  margin-right: 5px;
  font-weight: 600;
  font-size: 13px;
  color: #444444;
  font-family: ${poppins.string};
`;

export const StyledBlueBoldExplanationText = styled.div`
  font-weight: 600;
  font-size: 13px;

  background: linear-gradient(to right, #4276ee, #42beee); /* 원하는 그라데이션 */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  /* 아래는 일부 브라우저 호환을 위해 추가 */
  background-clip: text;
  color: transparent;
`;
  
export const StyledUpgradeButton = styled(Button)<{
  $subscriptionType?: string;
}>`
  width: 226px;
  height: 36px;
  background-color: #3075f6;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.3s, opacity 0.3s;
  font-family: ${poppins.string};
  gap: 4px;

  &:hover {
    color: #ffffff !important;
    background-color: #154ec7 !important;
  }

  &:hover:disabled {
    color: #000000 !important;
    background-color: inherit !important;
    cursor: not-allowed;
  }
`;

export const StyledComingUpDiv = styled.div`
  background-color: #d8e3fe;
  color: #4276ee;
  border-radius: 12px;
  font-weight: 600;
  font-family: ${poppins.string};
  font-size: 7px;
  padding: 1px 12px;
`;

export const ExclamationCircleOutlinedDiv = styled(ExclamationCircleOutlined)`
  color: #c1c1c1;
  font-size: 13px;
  cursor: pointer;
`;

export const PlanSegmented = styled(Segmented)`
  position: absolute;
  left: calc(50% - 80px);
  top: 0px;
  border-radius: 12px;
  border: 1px solid #eaeaea;
  background-color: white;
  font-size: 12px;
  font-family: ${poppins.string};
  font-weight: 500;

  .ant-segmented-item-selected {
    background-color: #4276ee;
    color: white;
    /* itemSelectedBg */
  }

  .ant-segmented-thumb {
    background-color: #d8e3fe;
  }

  .ant-segmented-item {
    border-radius: 12px;

    .button-wrapper {
      /* display: flex; */
      gap: 3px;
      justify-content: center;

      .discount {
        background-color: #d8e3fe;
        color: #4276ee;
        border-radius: 12px;
        font-weight: 600;
        font-family: ${poppins.string};
        font-size: 7px;
        padding: 2px 4px;
        margin-left: 3px;
      }

      .block {
        height: 36px;
      }
    }
  }
`;

export const SegmentedYearItem = styled.div`
  .discount {
    background-color: #d8e3fe;
    color: #4276ee;
    border-radius: 12px;
    font-weight: 600;
    font-family: ${poppins.string};
    font-size: 7px;
    padding: 1px 12px;
  }
`;

export const PaymentTextWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  /* align-items: center; */

  .text-space {
    display: flex;
    flex-direction: column;
    font-family: ${poppins.string};
    align-items: flex-start;

    text-align: left;
    

    .price-info {
      display: flex;
      align-items: flex-end;
      /* justify-content: space-; */

      .price {
        font-size: 30px;
        font-weight: 500;
        /* letter-spacing: -1px; */
      }

      .period {
        /* position: relative;
        right: 10px; */
        font-size: 16px;
        line-height: 40px;
        /* letter-spacing: -1px; */
      }

      .seat {
        font-size: 16px;
        line-height: 40px;
        /* letter-spacing: -1px; */
      }
    }

    .annuallyText {
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-bottom: 8px;
      color: #999999;
    }
  }

  .team-button-wrapper{
    display: flex;
    justify-content: center;
  }

  button {
    justify-content: center;
    align-items: center;
  }
`;

export const PricingDownloadModal = styled(Modal)`
  .content {
    padding: 10px;
    .text {
      text-align: center;
    }
  }
  .boldTxt {
    font-weight: 500;
    font-size: 14px;
  }
`;
